import React from 'react';
import NotFoundPage from './404';

const IndexPage = () => {
  return <NotFoundPage />
};

export default IndexPage;
